
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import services from "../../services/services";
import { useNavigate } from "react-router-dom";
import { encryptData } from "../../utils/encrypt";
import { Urls } from "../../services/Urls";
import useAuthStore from "../../Store/authStore";


export const useAuth = () => {
    const [loginData, setLoginData] = useState({
        user_loginname: "",
        pmo_criteria: ""
    });
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState({});
    const { getMyPermissions } = useAuthStore();
    const myPermission = useAuthStore((state) => state.myPermission);
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);


    useEffect(() => {
        if (myPermission?.length > 0)
            navigate("/")
    }, [myPermission])

    // Handle input values
    const handleChange = (e) => {
        const { name, value } = e.target;
        setLoginData({ ...loginData, [name]: value });
        setError({})
    };

    // This function handles login
    const handleLogin = async (e) => {
        e.preventDefault();
        if (error?.user_loginname) {
            return;
        }
        const errors = {}
        if (loginData?.user_loginname?.trim() === "") {
            errors.user_loginname = "Please enter email/employee code!"
        }
        if (loginData?.pmo_criteria?.trim() === "") {
            errors.pmo_criteria = "Please enter password!"
        }
        setError(errors);
        if (Object.keys(errors).length > 0) return
        setLoader(true)
        let ip;
        if (window.location.hostname === "172.25.22.67") {
            ip = "172.25.22.67"
        } else {
            try {
                const res = await axios.get(`https://api.ipify.org?format=json&t=${Date.now()}`);
                ip = res.data.ip
            } catch (error) {
                ip = ""
            }
        }
        const payload = {
            "user_loginname": loginData?.user_loginname,
            insights_criteria: encryptData(loginData.pmo_criteria, 'user_auth').toString(),
            ip_address_name: ip,
            "is_app_login": false,
            "unique_device_id": "",
            "is_mpin_login": false,
            "mpin_criteria": "",
            "appId": process.env.REACT_APP_PRODUCT_APP_ID
        };
        try {
            const response = await services.login(Urls("LOGIN"), payload);
            if (response.body.error_status === false) {
                sessionStorage.setItem("platform", "local");
                if (response?.body?.data[0]?.is_reset) {
                    navigate("/reset-password", { state: loginData.user_loginname })
                } else {
                    const token = encryptData(`Bearer ${response?.headers['x-auth-data']}`);
                    sessionStorage.setItem("token", token);
                    sessionStorage.setItem("user_code", encryptData(`${response.body.data[0].user_code}`));
                    sessionStorage.setItem("notification", response?.body?.data[0]?.is_notification_enable);
                    try {
                        await getMyPermissions("login");
                    } catch (error) {
                        console.error(error);
                        setError({ apiError: "A temporary issue occurred on the Insights server! Please try again later." });
                    }
                }
            } else {
                setError({ apiError: response.body.message });
            }
            setLoader(false)
        } catch (err) {
            setLoader(false)
            console.error(err);
            setError({ apiError: err?.response?.data?.errorMessage });
        }
    };


    return useMemo(() => ({
        showPassword, setShowPassword, loginData, handleChange, error, handleLogin, loader
    }), [showPassword, setShowPassword, loginData, handleChange, error, handleLogin, loader]);
};